<template>
  <v-tabs icons-and-text v-model="active">
    <v-tabs-slider color="primary"></v-tabs-slider>

    <v-tab
      href="#tab-11"
      @change="
        loadState(0);
        activeState = 0;
      "
    >
      <v-badge color="red">
        <span slot="badge" v-if="labelsStats">{{ labelsStats }}</span>
        Pending Labels
      </v-badge>
    </v-tab>

    <v-tab
      href="#tab-12"
      @change="
        loadState(1);
        activeState = 1;
      "
    >
      <v-badge color="red">
        <span slot="badge" v-if="packingStats">{{ packingStats }}</span>
        Pending Packing
      </v-badge>
    </v-tab>

    <v-tab
      href="#tab-13"
      @change="
        loadState(2);
        activeState = 2;
      "
    >
      <v-badge color="red">
        <span slot="badge" v-if="pickupStats">{{ pickupStats }}</span>
        Pending Pick Up
      </v-badge>
    </v-tab>
    <v-tab
      href="#tab-14"
      @change="
        loadState(3);
        activeState = 3;
      "
    >
      <v-badge color="red">
        <span slot="badge" v-if="deliveryStats">{{ deliveryStats }}</span>
        Pending Delivery
      </v-badge>
    </v-tab>
    <v-tab-item value="tab-11">
      <pending-labels
        :orders="orders['0']"
        @reload="loadState(0)"
        @updateState="updateState($event)"
      ></pending-labels>
    </v-tab-item>
    <v-tab-item value="tab-12">
      <pending-packaging
        :orders="orders['1']"
        @updateState="updateState($event)"
      ></pending-packaging>
    </v-tab-item>
    <v-tab-item value="tab-13">
      <pending-pickup
        :orders="orders['2']"
        :executives="executives"
        @updateState="updateState($event)"
      ></pending-pickup>
    </v-tab-item>
    <v-tab-item value="tab-14">
      <pending-delivery
        :orders="orders['3']"
        @markDelivered="markDelivered($event)"
      ></pending-delivery>
    </v-tab-item>
  </v-tabs>
</template>
<script type="text/javascript">
import api from '@/api';
import Vue from 'vue';
import PendingLabels from './pending-labels';
import PendingPackaging from './pending-packaging';
import PendingPickup from './pending-pickup';
import PendingDelivery from './pending-delivery';
export default {
  data() {
    return {
      orders: [[], [], [], []],
      activeState: 0,
      active: 'tab-11',
      executives: [],
      stats: [],
    };
  },
  created() {
    if (this.vid) this.loadState(this.activeState);
  },
  watch: {
    vid() {
      this.loadState(this.activeState);
    },
  },
  computed: {
    vid() {
      return this.$store.state.vid;
    },
    labelsStats() {
      let s = this.stats.find(s => s.state == 0);
      if (s) return s.ordersCount;
      else return 0;
    },
    packingStats() {
      let s = this.stats.find(s => s.state == 1);
      if (s) return s.ordersCount;
      else return 0;
    },
    pickupStats() {
      let s = this.stats.find(s => s.state == 2);
      if (s) return s.ordersCount;
      else return 0;
    },
    deliveryStats() {
      let s = this.stats.find(s => s.state == 3);
      if (s) return s.ordersCount;
      else return 0;
    },
  },
  methods: {
    updateState(state) {
      let loader = this.$loading.show();
      api
        .put('orders/bulk/stage', state)
        .then(r => {
          loader.hide();
          this.activeState = state.stage;
          this.loadState(state.stage);
          this.active = 'tab-1' + (parseInt(state.stage) + 1);
        })
        .catch(async err => {
          console.log(err);
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.updateState(state);
            }
          }
        });
    },
    markDelivered(state) {
      let loader = this.$loading.show();
      api
        .post('orders/bulk/delivered', state)
        .then(r => {
          loader.hide();
          this.loadState(this.activeState);
        })
        .catch(async err => {
          console.log(err);
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.markDelivered(state);
            }
          }
        });
    },
    loadState(state) {
      let loader = this.$loading.show();
      api
        .get('orders/bulk/stage/' + state)
        .then(r => {
          Vue.set(this.orders, state, r.data);
          // this.stats = r.data.stats;
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.loadState(state);
            }
          }
        });
      if (state == '2')
        api.get('executives').then(r => {
          this.executives = r.data;
        });
    },
  },
  components: {
    PendingLabels,
    PendingPackaging,
    PendingPickup,
    PendingDelivery,
  },
};
</script>
